/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import React from "react";
import KeyBenefitsList from "Components/KeyBenefitsList/KeyBenefitsList";
import { IBenefitManagementContainerProps } from "./IBenefitManagementContainerProps";
import { IProfileBenefitManager } from "Interfaces/Benefits/IProfileBenefitManager";

/**
 * Component to render the benefits using YAML.
 * @param {IBenefitManagementContainerProps} props
 * @returns {JSX.Element}
 */
const BenefitManagementContainer = (props: IBenefitManagementContainerProps) => {
  const { benefitManager, canManageBenefits, userProfileId, assignBenefitClicked } = props;

  return (
    <>
      {benefitManager &&
        benefitManager.length > 0 &&
        benefitManager.map((benefitItem: IProfileBenefitManager, index) => {
          return (
            <KeyBenefitsList
              key={index}
              benefitManagerId={benefitItem.id}
              benefitType={benefitItem.displayName}
              assignBenefitClicked={assignBenefitClicked}
              userProfileId={userProfileId}
              benefits={benefitItem.benefits}
              canManageBenefits={canManageBenefits}
            />
          );
        })}
    </>
  );
};

export default BenefitManagementContainer;
